import type { FC } from "react";

import classNames from "classnames";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";

import styles from "./FlavourCarouselThumbnail.module.scss";

type FlavourCarouselThumbnailProps = {
  imageUrl: string;
  title: string;
  theme: "light" | "dark";
  color: string;
  isActive?: boolean;
  index: number;
  selectFlavour: (index: number) => void;
};

export const FlavourCarouselThumbnail: FC<FlavourCarouselThumbnailProps> = ({
  imageUrl,
  title,
  color,
  isActive = false,
  theme,
  index,
  selectFlavour,
}) => {
  return (
    <button
      className={classNames(styles.thumbnail, { ["dark-theme"]: theme === "dark", ["light-theme"]: theme === "light" })}
      type="button"
      aria-label={title}
      onClick={() => selectFlavour(index)}
    >
      <div className={styles.imageWrapper}>
        <ImageBehaviour className={styles.image} src={imageUrl} alt="" />
      </div>
      <span className={styles.title}>{title}</span>
      <div
        className={classNames(styles.backgroundLayer, { [styles.active]: isActive })}
        style={{ background: color }}
        data-testid="background-layer"
      ></div>
    </button>
  );
};
